module.exports = "pegasus/assets/themelp1/product/107.png";